var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.136,
    height: 9.763,
    viewBox: "0 0 16.136 9.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2a2a2a;stroke:#2a2a2a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.568 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.816,127.429a.626.626,0,0,0-.888,0L7.5,134.483l-6.429-7.053a.626.626,0,0,0-.888,0,.633.633,0,0,0,0,.892l6.841,7.506a.619.619,0,0,0,.475.179.618.618,0,0,0,.475-.179l6.841-7.507A.632.632,0,0,0,14.816,127.429Z",
    transform: "translate(0 -127.244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.76f84793624795fd2809dcf609185079.svg";
export { ForwardRef as ReactComponent };